import { RestaurantListItem as RestaurantListItemCore, LinkType } from "@parksandresorts/core";
import SiteConfigurationStore from "components/stores/site-configuration-store";

const FALLBACK_TITLE = ""; //In practice this should never happen since the Contentful model requires a title. But just in case, we'll fallback to an empty string so RestaurantListItemCore doesn't break.

const RestaurantListItem = (props: any) => {
  return (
    <RestaurantListItemCore
      image={props.imageInList?.gatsbyImageData}
      imageAlt={props.imageInList?.description}
      title={props.title ?? FALLBACK_TITLE}
      bodyText={props.shortDescriptionInList}
      linkUrl={props.linkData?.linkUrl}
      linkType={props.linkData?.isExternalLink ? LinkType.EXTERNAL : LinkType.INTERNAL}
      foodTerminalId={props.foodTerminalId}
      shouldShowWarningModal={props.shouldShowWarningModal}
      shouldShowBlockingModal={props.shouldShowBlockingModal}
      isParkOpenNow={props.isParkOpenNow}
      labels={{
        labelUnderImage: props.shouldShowLabelUnderImage ? props.label : null,
        readMore: SiteConfigurationStore.getLabel("READMORE"),
        waitTimeLabelPrefix: SiteConfigurationStore.getLabel("WAIT_TIME_CURRENT"),
        waitTimeFullQueue: SiteConfigurationStore.getLabel("WAIT_TIME_FULL_QUEUE_WARNING"),
        waitTimeLabel: props.waitTimeLabel,
        waitTimeModalHeaderFullQueue: SiteConfigurationStore.getLabel("WAIT_TIME_MODAL_HEADER_FULL_QUEUE"),
        waitTimeModalHeaderLongQueue: SiteConfigurationStore.getLabel("WAIT_TIME_MODAL_HEADER_LONG_QUEUE"),
        waitTimePaused: SiteConfigurationStore.getLabel("WAIT_TIME_LEVEL_PAUSED"),
        goBackButtonLabel: SiteConfigurationStore.getLabel("WAIT_TIME_MODAL_BUTTON_BACK"),
        continueButtonLabel: SiteConfigurationStore.getLabel("WAIT_TIME_MODAL_BUTTON_CONTINUE"),
      }}
    />
  );
};

export default RestaurantListItem;
